import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React, { useCallback } from 'react';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import { connect } from 'react-redux';
import { deliverySelector } from 'selectors/new-booking-selectors';
import NewBookingDuck from 'ducks/new-booking-duck';
import DeliveryContext from '../../common/context';
import AddressSelector from './address-selector';

const PickUpAddressSelector = ({ dispatch, deliveryID, delivery, onClose }) => {
  const onPickUpAddressChange = useCallback(
    (newDeliverySteps, forceRefresh) => {
      dispatch(
        NewBookingDuck.creators.setPickUp(
          deliveryID,
          newDeliverySteps[0] || {},
        ),
      );

      if (forceRefresh) {
        dispatch(NewBookingDuck.creators.refreshDeliveryIDVersion(deliveryID));
      }
    },
    [dispatch, deliveryID],
  );

  if (!delivery) {
    return null;
  }

  const pickUpStep = _get(delivery, 'detail.pickUp');

  return (
    <DeliveryContext.Provider value={delivery}>
      <AddressSelector
        key={`pickup-${deliveryID}`}
        deliveryID={deliveryID}
        deliverySteps={pickUpStep ? [pickUpStep] : null}
        onChange={onPickUpAddressChange}
        isPickUp
        allowMultiple={false}
        onClose={onClose}
        addAddressPlaceholder={I18n.t(
          'v2.locationDrawer.placeholder.addPickupLocation',
        )}
      />
    </DeliveryContext.Provider>
  );
};

PickUpAddressSelector.propTypes = {
  delivery: NewBookingDeliveryPropType.isRequired,
  deliveryID: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default connect((state, props) => ({
  delivery: deliverySelector(state, props),
}))(PickUpAddressSelector);
